// Adding native submit button to the form 
function addPaymentButton() {
    setTimeout(() => {
        const paymentHTMLJS = document.querySelector("#sk-Travel-Payment-PaymentRedirectionRequestHTMLJS")
        if(!paymentHTMLJS) return
        
        const form = document.forms["frm"];
        if(!form) return

        //Creating a form submit button
        const submitButton = document.createElement("button");
        submitButton.type = "submit";
        submitButton.textContent = "PAY";
        submitButton.classList.add("sk-button","button","sk-button--action","Action","payment-button"); 

        const targetButton = document.querySelector('#GIGCreateTravelPolicyProcess-Payment-next-button-1');
        if (targetButton) {

            const buttonWidth = targetButton.offsetWidth;
            submitButton.style.width = buttonWidth + 'px';
        } 

        //Adding the form submit button inside the form
        form.appendChild(submitButton);

    }, 1000);
}

export { addPaymentButton };